module.exports = __webpack_public_path__ + "img/tournament_created.71d33b9.svg";